module.exports = __webpack_public_path__ + "img/gsb.5a83e32f.svg";